import {
    AboutUs,
    CTA,
    FAQs,
    Footer,
    Guarantees,
    Header,
    Hero,
    HighlightedFeatures,
    HighlightedServices,
    OurProcess,
    OurTeam,
    OurWork,
    Qualifications,
    RequestQuote,
    ServiceArea,
    Testimonials,
    TradeCategories,
} from "import.meta.replace.TEMPLATE_COMPONENT_LIBRARY";
import type { TemplateProps } from "../utils/types/template-type";

interface Props {
    transformedData: TemplateProps;
}

export const Template = ({ transformedData }: Props) => {
    const {
        aboutUs,
        cta,
        faqs,
        footer,
        guarantees,
        header,
        hero,
        highlightedFeatures,
        highlightedServices,
        ourTeam,
        ourWork,
        qualifications,
        requestQuote,
        serviceArea,
        testimonials,
        tradeCategories,
        ourProcess,
    } = transformedData;

    const template = import.meta.env.PUBLIC_TEMPLATE;
    switch (template) {
        case "bright-hive": // bright hive
            return (
                <main>
                    <header>
                        <Header {...header} />
                    </header>
                    <Hero {...hero} />
                    <AboutUs {...aboutUs} />
                    <HighlightedServices {...highlightedServices} client:visible={{ rootMargin: "200px" }} />
                    <HighlightedFeatures {...highlightedFeatures} client:visible={{ rootMargin: "200px" }} />
                    <OurWork {...ourWork} client:visible={{ rootMargin: "200px" }} />
                    <TradeCategories {...tradeCategories} />
                    <OurProcess {...ourProcess} />
                    <Guarantees {...guarantees} />
                    <OurTeam {...ourTeam} />
                    <Testimonials {...testimonials} />
                    <FAQs {...faqs} />
                    <CTA {...cta} />
                    <Qualifications {...qualifications} />
                    <RequestQuote {...requestQuote} />
                    <ServiceArea {...serviceArea} />
                    <footer>
                        <Footer {...footer} />
                    </footer>
                </main>
            );

        case "neon-volt": // neon volt
            return (
                <main>
                    <header>
                        <Header {...header} />
                    </header>
                    <Hero {...hero} />
                    <AboutUs {...aboutUs} />
                    <HighlightedFeatures {...highlightedFeatures} client:visible={{ rootMargin: "200px" }} />
                    <HighlightedServices {...highlightedServices} client:visible={{ rootMargin: "200px" }} />
                    <Guarantees {...guarantees} />
                    <OurProcess {...ourProcess} />
                    <Qualifications {...qualifications} />
                    <TradeCategories {...tradeCategories} />
                    <OurWork {...ourWork} client:visible={{ rootMargin: "200px" }} />
                    <FAQs {...faqs} />
                    <RequestQuote {...requestQuote} />
                    <OurTeam {...ourTeam} />
                    <Testimonials {...testimonials} />
                    <ServiceArea {...serviceArea} />
                    <CTA {...cta} />
                    <footer>
                        <Footer {...footer} />
                    </footer>
                </main>
            );

        case "black-velvet": // black velvet
            return (
                <main>
                    <header>
                        <Header {...header} />
                    </header>
                    <Hero {...hero} />
                    <AboutUs {...aboutUs} />
                    <CTA {...cta} />
                    <FAQs {...faqs} />
                    <Guarantees {...guarantees} />
                    <HighlightedFeatures {...highlightedFeatures} client:visible={{ rootMargin: "200px" }} />
                    <HighlightedServices {...highlightedServices} client:visible={{ rootMargin: "200px" }} />
                    <OurProcess {...ourProcess} />
                    <OurWork {...ourWork} client:visible={{ rootMargin: "200px" }} />
                    <OurTeam {...ourTeam} />
                    <Qualifications {...qualifications} />
                    <Testimonials {...testimonials} />
                    <RequestQuote {...requestQuote} />
                    <TradeCategories {...tradeCategories} />
                    <ServiceArea {...serviceArea} />
                    <footer>
                        <Footer {...footer} />
                    </footer>
                </main>
            );
        case "ashen-elegance": // ashen elegance
            return (
                <main>
                    <header>
                        <Header {...header} />
                    </header>
                    <Hero {...hero} />
                    <AboutUs {...aboutUs} />
                    <HighlightedServices {...highlightedServices} client:visible={{ rootMargin: "200px" }} />
                    <HighlightedFeatures {...highlightedFeatures} client:visible={{ rootMargin: "200px" }} />
                    <CTA {...cta} />
                    <Qualifications {...qualifications} />
                    <OurProcess {...ourProcess} />
                    <FAQs {...faqs} />
                    <OurWork {...ourWork} client:visible={{ rootMargin: "200px" }} />
                    <OurTeam {...ourTeam} />
                    <Testimonials {...testimonials} />
                    <TradeCategories {...tradeCategories} />
                    <RequestQuote {...requestQuote} />
                    <Guarantees {...guarantees} />
                    <ServiceArea {...serviceArea} />

                    <footer>
                        <Footer {...footer} />
                    </footer>
                </main>
            );
        case "jade-oasis": // jade oasis
            return (
                <main>
                    <header>
                        <Header {...header} />
                    </header>
                    <Hero {...hero} />
                    <AboutUs {...aboutUs} />
                    <OurProcess {...ourProcess} />
                    <HighlightedFeatures {...highlightedFeatures} client:visible={{ rootMargin: "200px" }} />
                    <Guarantees {...guarantees} />
                    <Qualifications {...qualifications} />
                    <HighlightedServices {...highlightedServices} client:visible={{ rootMargin: "200px" }} />
                    <OurTeam {...ourTeam} />
                    <Testimonials {...testimonials} />
                    <CTA {...cta} />
                    <RequestQuote {...requestQuote} />
                    <OurWork {...ourWork} client:visible={{ rootMargin: "200px" }} />
                    <FAQs {...faqs} />
                    <TradeCategories {...tradeCategories} />
                    <ServiceArea {...serviceArea} />

                    <footer>
                        <Footer {...footer} />
                    </footer>
                </main>
            );
        case "slate-serenity": // slate serenity
            return (
                <main>
                    <header>
                        <Header {...header} />
                    </header>
                    <Hero {...hero} />
                    <AboutUs {...aboutUs} />
                    <HighlightedFeatures {...highlightedFeatures} client:visible={{ rootMargin: "200px" }} />
                    <HighlightedServices {...highlightedServices} client:visible={{ rootMargin: "200px" }} />
                    <Guarantees {...guarantees} />
                    <OurProcess {...ourProcess} />
                    <Qualifications {...qualifications} />
                    <TradeCategories {...tradeCategories} />
                    <OurWork {...ourWork} client:visible={{ rootMargin: "200px" }} />
                    <FAQs {...faqs} />
                    <RequestQuote {...requestQuote} />
                    <OurTeam {...ourTeam} />
                    <Testimonials {...testimonials} />
                    <CTA {...cta} />
                    <ServiceArea {...serviceArea} />

                    <footer>
                        <Footer {...footer} />
                    </footer>
                </main>
            );
        case "golden-moments": // golden moments
            return (
                <main>
                    <header>
                        <Header {...header} />
                    </header>
                    <Hero {...hero} />
                    <AboutUs {...aboutUs} />
                    <HighlightedServices {...highlightedServices} client:visible={{ rootMargin: "200px" }} />
                    <RequestQuote {...requestQuote} />
                    <OurWork {...ourWork} client:visible={{ rootMargin: "200px" }} />
                    <Qualifications {...qualifications} />
                    <OurProcess {...ourProcess} />
                    <OurTeam {...ourTeam} />
                    <HighlightedFeatures {...highlightedFeatures} client:visible={{ rootMargin: "200px" }} />
                    <Testimonials {...testimonials} />
                    <TradeCategories {...tradeCategories} />
                    <Guarantees {...guarantees} />
                    <ServiceArea {...serviceArea} />
                    <FAQs {...faqs} />
                    <CTA {...cta} />
                    <footer>
                        <Footer {...footer} />
                    </footer>
                </main>
            );
        case "twilight-hues": // twilight hues
            return (
                <main>
                    <header>
                        <Header {...header} />
                    </header>
                    <Hero {...hero} />
                    <AboutUs {...aboutUs} />
                    <Guarantees {...guarantees} />
                    <HighlightedServices {...highlightedServices} client:visible={{ rootMargin: "200px" }} />
                    <TradeCategories {...tradeCategories} />
                    <RequestQuote {...requestQuote} />
                    <OurProcess {...ourProcess} />
                    <CTA {...cta} />
                    <OurTeam {...ourTeam} />
                    <Testimonials {...testimonials} />
                    <OurWork {...ourWork} client:visible={{ rootMargin: "200px" }} />
                    <Qualifications {...qualifications} />
                    <HighlightedFeatures {...highlightedFeatures} client:visible={{ rootMargin: "200px" }} />
                    <FAQs {...faqs} />
                    <ServiceArea {...serviceArea} />

                    <footer>
                        <Footer {...footer} />
                    </footer>
                </main>
            );
        case "ruby-radiance": // ruby radiance
            // this one has 2 highlightedFeatures and 2 CTA
            return (
                <main>
                    <header>
                        <Header {...header} />
                    </header>
                    <Hero {...hero} />
                    <HighlightedFeatures {...highlightedFeatures} client:visible={{ rootMargin: "200px" }} />
                    <AboutUs {...aboutUs} />
                    <OurProcess {...ourProcess} />
                    <Qualifications {...qualifications} />
                    <OurTeam {...ourTeam} />
                    <HighlightedServices {...highlightedServices} client:visible={{ rootMargin: "200px" }} />
                    <Guarantees {...guarantees} />
                    <CTA {...cta} />
                    <OurWork {...ourWork} client:visible={{ rootMargin: "200px" }} />
                    <Testimonials {...testimonials} />
                    <FAQs {...faqs} />
                    <RequestQuote {...requestQuote} />
                    <TradeCategories {...tradeCategories} />
                    <ServiceArea {...serviceArea} />

                    <footer>
                        <Footer {...footer} />
                    </footer>
                </main>
            );
        case "modern-sky": // modern sky
            return (
                <main>
                    <header>
                        <Header {...header} />
                    </header>
                    <Hero {...hero} />
                    <AboutUs {...aboutUs} />
                    <HighlightedServices {...highlightedServices} client:visible={{ rootMargin: "200px" }} />
                    <HighlightedFeatures {...highlightedFeatures} client:visible={{ rootMargin: "200px" }} />
                    <OurWork {...ourWork} client:visible={{ rootMargin: "200px" }} />
                    <TradeCategories {...tradeCategories} />
                    <OurProcess {...ourProcess} />
                    <Guarantees {...guarantees} />
                    <OurTeam {...ourTeam} />
                    <Testimonials {...testimonials} />
                    <Qualifications {...qualifications} />
                    <FAQs {...faqs} />
                    <CTA {...cta} />
                    <RequestQuote {...requestQuote} />
                    <ServiceArea {...serviceArea} />
                    <footer>
                        <Footer {...footer} />
                    </footer>
                </main>
            );
        case "dark-night": // dark night
            return (
                <main>
                    <header>
                        <Header {...header} />
                    </header>
                    <Hero {...hero} />
                    <AboutUs {...aboutUs} />
                    <CTA {...cta} />
                    <FAQs {...faqs} />
                    <Guarantees {...guarantees} />
                    <HighlightedFeatures {...highlightedFeatures} client:visible={{ rootMargin: "200px" }} />
                    <HighlightedServices {...highlightedServices} client:visible={{ rootMargin: "200px" }} />
                    <OurProcess {...ourProcess} />
                    <OurWork {...ourWork} client:visible={{ rootMargin: "200px" }} />
                    <OurTeam {...ourTeam} />
                    <Qualifications {...qualifications} />
                    <Testimonials {...testimonials} />
                    <RequestQuote {...requestQuote} />
                    <TradeCategories {...tradeCategories} />
                    <ServiceArea {...serviceArea} />
                    <footer>
                        <Footer {...footer} />
                    </footer>
                </main>
            );
        case "cocoa-tiles": // cocoa tiles
            return (
                <main>
                    <header>
                        <Header {...header} />
                    </header>
                    <Hero {...hero} />
                    <AboutUs {...aboutUs} />
                    <HighlightedServices {...highlightedServices} client:visible={{ rootMargin: "200px" }} />
                    <HighlightedFeatures {...highlightedFeatures} client:visible={{ rootMargin: "200px" }} />
                    <OurWork {...ourWork} client:visible={{ rootMargin: "200px" }} />
                    <TradeCategories {...tradeCategories} />
                    <OurProcess {...ourProcess} />
                    <Qualifications {...qualifications} />
                    <Guarantees {...guarantees} />
                    <OurTeam {...ourTeam} />
                    <Testimonials {...testimonials} />
                    <FAQs {...faqs} />
                    <CTA {...cta} />
                    <RequestQuote {...requestQuote} />
                    <ServiceArea {...serviceArea} />
                    <footer>
                        <Footer {...footer} />
                    </footer>
                </main>
            );
        case "amber-wood": // amber wood
            return (
                <main>
                    <header>
                        <Header {...header} />
                    </header>
                    <Hero {...hero} />
                    <AboutUs {...aboutUs} />
                    <HighlightedServices {...highlightedServices} client:visible={{ rootMargin: "200px" }} />
                    <HighlightedFeatures {...highlightedFeatures} client:visible={{ rootMargin: "200px" }} />
                    <CTA {...cta} />
                    <Qualifications {...qualifications} />
                    <OurProcess {...ourProcess} />
                    <FAQs {...faqs} />
                    <OurWork {...ourWork} client:visible={{ rootMargin: "200px" }} />
                    <OurTeam {...ourTeam} />
                    <Testimonials {...testimonials} />
                    <TradeCategories {...tradeCategories} />
                    <RequestQuote {...requestQuote} />
                    <Guarantees {...guarantees} />
                    <ServiceArea {...serviceArea} />

                    <footer>
                        <Footer {...footer} />
                    </footer>
                </main>
            );
        case "verdant-vibes": // verdant vibes
            return (
                <main>
                    <header>
                        <Header {...header} />
                    </header>
                    <Hero {...hero} />
                    <AboutUs {...aboutUs} />
                    <HighlightedServices {...highlightedServices} client:visible={{ rootMargin: "200px" }} />
                    <HighlightedFeatures {...highlightedFeatures} client:visible={{ rootMargin: "200px" }} />
                    <CTA {...cta} />
                    <Qualifications {...qualifications} />
                    <OurProcess {...ourProcess} />
                    <FAQs {...faqs} />
                    <OurWork {...ourWork} client:visible={{ rootMargin: "200px" }} />
                    <OurTeam {...ourTeam} />
                    <Testimonials {...testimonials} />
                    <TradeCategories {...tradeCategories} />
                    <RequestQuote {...requestQuote} />
                    <Guarantees {...guarantees} />
                    <ServiceArea {...serviceArea} />

                    <footer>
                        <Footer {...footer} />
                    </footer>
                </main>
            );
        case "warm-breeze": // warm breeze
            return (
                <main>
                    <header>
                        <Header {...header} />
                    </header>
                    <Hero {...hero} />
                    <AboutUs {...aboutUs} />
                    <HighlightedServices {...highlightedServices} client:visible={{ rootMargin: "200px" }} />
                    <HighlightedFeatures {...highlightedFeatures} client:visible={{ rootMargin: "200px" }} />
                    <CTA {...cta} />
                    <Qualifications {...qualifications} />
                    <OurProcess {...ourProcess} />
                    <FAQs {...faqs} />
                    <OurWork {...ourWork} client:visible={{ rootMargin: "200px" }} />
                    <OurTeam {...ourTeam} />
                    <Testimonials {...testimonials} />
                    <TradeCategories {...tradeCategories} />
                    <RequestQuote {...requestQuote} />
                    <Guarantees {...guarantees} />
                    <ServiceArea {...serviceArea} />

                    <footer>
                        <Footer {...footer} />
                    </footer>
                </main>
            );
        case "blue-waves": // blue waves
            return (
                <main>
                    <header>
                        <Header {...header} />
                    </header>
                    <Hero {...hero} />
                    <AboutUs {...aboutUs} />
                    <CTA {...cta} />
                    <FAQs {...faqs} />
                    <Guarantees {...guarantees} />
                    <HighlightedFeatures {...highlightedFeatures} client:visible={{ rootMargin: "200px" }} />
                    <HighlightedServices {...highlightedServices} client:visible={{ rootMargin: "200px" }} />
                    <OurProcess {...ourProcess} />
                    <OurWork {...ourWork} client:visible={{ rootMargin: "200px" }} />
                    <OurTeam {...ourTeam} />
                    <Qualifications {...qualifications} />
                    <Testimonials {...testimonials} />
                    <RequestQuote {...requestQuote} />
                    <TradeCategories {...tradeCategories} />
                    <ServiceArea {...serviceArea} />
                    <footer>
                        <Footer {...footer} />
                    </footer>
                </main>
            );
        case "new-horizon": // new horizon
            return (
                <main>
                    <header>
                        <Header {...header} />
                    </header>
                    <Hero {...hero} />
                    <AboutUs {...aboutUs} />
                    <HighlightedServices {...highlightedServices} client:visible={{ rootMargin: "200px" }} />
                    <HighlightedFeatures {...highlightedFeatures} client:visible={{ rootMargin: "200px" }} />
                    <OurWork {...ourWork} client:visible={{ rootMargin: "200px" }} />
                    <TradeCategories {...tradeCategories} />
                    <OurProcess {...ourProcess} />
                    <Guarantees {...guarantees} />
                    <OurTeam {...ourTeam} />
                    <Testimonials {...testimonials} />
                    <FAQs {...faqs} />
                    <CTA {...cta} />
                    <RequestQuote {...requestQuote} />
                    <ServiceArea {...serviceArea} />
                    <footer>
                        <Footer {...footer} />
                    </footer>
                </main>
            );
        case "crystal-peak": // crystal peak
            return (
                <main>
                    <header>
                        <Header {...header} />
                    </header>
                    <Hero {...hero} />
                    <AboutUs {...aboutUs} />
                    <HighlightedServices {...highlightedServices} client:visible={{ rootMargin: "200px" }} />
                    <HighlightedFeatures {...highlightedFeatures} client:visible={{ rootMargin: "200px" }} />
                    <OurWork {...ourWork} client:visible={{ rootMargin: "200px" }} />
                    <TradeCategories {...tradeCategories} />
                    <OurProcess {...ourProcess} />
                    <Guarantees {...guarantees} />
                    <OurTeam {...ourTeam} />
                    <Testimonials {...testimonials} />
                    <FAQs {...faqs} />
                    <CTA {...cta} />
                    <RequestQuote {...requestQuote} />
                    <ServiceArea {...serviceArea} />
                    <footer>
                        <Footer {...footer} />
                    </footer>
                </main>
            );
        case "navy-nebula": // navy nebula
            return (
                <main>
                    <header>
                        <Header {...header} />
                    </header>
                    <Hero {...hero} />
                    <AboutUs {...aboutUs} />
                    <CTA {...cta} />
                    <OurTeam {...ourTeam} />
                    <HighlightedServices {...highlightedServices} client:visible={{ rootMargin: "200px" }} />
                    <Guarantees {...guarantees} />
                    <OurWork {...ourWork} client:visible={{ rootMargin: "200px" }} />
                    <FAQs {...faqs} />
                    <HighlightedFeatures {...highlightedFeatures} client:visible={{ rootMargin: "200px" }} />
                    <OurProcess {...ourProcess} />
                    <Qualifications {...qualifications} />
                    <TradeCategories {...tradeCategories} />
                    <RequestQuote {...requestQuote} />
                    <Testimonials {...testimonials} />
                    <ServiceArea {...serviceArea} />

                    <footer>
                        <Footer {...footer} />
                    </footer>
                </main>
            );
        case "cobalt-cascade": // cobalt cascade
            return (
                <main>
                    <header>
                        <Header {...header} />
                    </header>
                    <Hero {...hero} />
                    <AboutUs {...aboutUs} />
                    <HighlightedServices {...highlightedServices} client:visible={{ rootMargin: "200px" }} />
                    <HighlightedFeatures {...highlightedFeatures} client:visible={{ rootMargin: "200px" }} />
                    <OurWork {...ourWork} client:visible={{ rootMargin: "200px" }} />
                    <TradeCategories {...tradeCategories} />
                    <OurProcess {...ourProcess} />
                    <Qualifications {...qualifications} />
                    <Guarantees {...guarantees} />
                    <OurTeam {...ourTeam} />
                    <Testimonials {...testimonials} />
                    <FAQs {...faqs} />
                    <CTA {...cta} />
                    <RequestQuote {...requestQuote} />
                    <ServiceArea {...serviceArea} />
                    <footer>
                        <Footer {...footer} />
                    </footer>
                </main>
            );
        default:
            break;
    }
};
